import { FULL_CARD_SIZES } from '../cardsTypes';
import StandardLearningContentCard from './StandardLearningContentCard';
import { ReducedLearningContentCard } from './ReducedLearningContentCard';
import { jsx as _jsx } from "react/jsx-runtime";
export const LearningContentCard = props => !props.size || FULL_CARD_SIZES.includes(props.size) ? /*#__PURE__*/_jsx(StandardLearningContentCard, Object.assign({}, props)) : /*#__PURE__*/_jsx(ReducedLearningContentCard, Object.assign({}, props));
export default LearningContentCard;